/**
 * Billing class contract (RBAC area: `products`).
 *
 * A billing class determines how a logged hour is billed, independently of the
 * service category's rate. Every time entry carries both a service category (which
 * sets the rate) and a billing class (which sets the billing behavior):
 *
 *   - `bill`       — the service category rate passes through to billing/invoice.
 *   - `no_charge`  — the hour appears on the invoice but at $0.
 *   - `no_bill`    — the hour is excluded from the invoice entirely.
 *
 * `showOnInvoice` controls whether the line is rendered on the customer invoice
 * (true for `bill` and `no_charge`, false for `no_bill`). Exactly one billing class
 * is the default applied to new time entries.
 */
export const BILLING_CLASS_BILL_TYPES = ['bill', 'no_charge', 'no_bill'];
//# sourceMappingURL=billing-class.js.map